<template>
  <div>
    <el-dialog
      title="查看权重"
      v-model="visible"
      :close-on-click-modal="false"
      width="760px"
      :visible.sync="visible"
      :before-close="handleClose"
    >
      <!--工具条-->
    <el-form :model="filters" class="toolbar" ref="filters" label-width="80px">
      <el-row style="padding-bottom: 0px;">
        <el-col :span="8">
          <el-form-item label="商品大类" prop="dept">
            <el-select
              v-model="filters.dept"
              filterable
              placeholder="请选择"
              disabled
            >
              <el-option
                v-for="(item,i) in goodsList"
                :key="i"
                :label="item.CODE + ' ' + item.NAME"
                :value="item.CODE"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item label="棚格图分类" prop="spaceclassNew">
            <el-select
              v-model="filters.spaceclassNew"
              filterable
              placeholder="请选择"
              :disabled="pgtDisable"
              @change="search"
            >
              <el-option
                v-for="(item,i) in List"
                :key="i"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="6">
          <el-form-item label="细分类" prop="ssubclass">
            <el-select v-model="filters.ssubclass" filterable placeholder="请选择" class="ssubSelect">
              <el-option
                v-for="(item,i) in ssubList"
                :key="i"
                :label="item.ssubclass + ' ' + item.ssubName"
                :value="item.ssubclass"
              ></el-option>
            </el-select>
            <div class="ssubError">请选择细分类</div>
          </el-form-item>
        </el-col> -->
      </el-row>
      <el-row style="padding-bottom: 0px;">
        <el-col :span="12">
          <div style="display:flex;">
          <el-form-item
            label="选品模式"
            prop="sipMode"
          >
            <el-select v-model="filters.sipMode" placeholder="请选择" disabled>
              <el-option label="季节性选品" value="1"></el-option>
              <el-option label="非季节性选品" value="2"></el-option>
            </el-select>
            <div class="sipError">请选择</div>
          </el-form-item>
          <el-form-item label prop="sipIndication" class="leftModelNolabel">
            <el-select v-model="filters.sipIndication" placeholder="请选择" disabled>
              <el-option label="上半年" value="1"></el-option>
              <el-option label="下半年" value="2"></el-option>
              <el-option label="夏季" value="3"></el-option>
              <el-option label="冬季" value="4"></el-option>
            </el-select>
            <div class="sipInError">请选择</div>
          </el-form-item>
          </div>
        </el-col>
        <!-- <el-col :span="6">
          <el-form-item class="leftNolabel">
            <el-button type="primary" @click="search()">
              <i class="el-icon-search"></i>查询
            </el-button>
          </el-form-item>
        </el-col> -->
      </el-row>
    </el-form>
    
    <div v-show="tableShowOne">
      <div style="padding-bottom:10px;" class="clearfix">
      <!-- <h3 class="fl">商品分类：洗发水</h3> -->
      <h3 style="text-align:right;">版本：{{wijIwfversion}}</h3>
    </div>
    <!-- 列表 -->
    <el-table
      :data="planLists"
      class="listTowline"
      highlight-current-row
      v-loading="listLoading"
      style="width: 100%;"
      
    >
      <el-table-column label="一级指标" width="180">
        <template slot-scope="scope">
          <span v-if="scope.row.wijPid == null">{{scope.row.wijKeyName}}</span>
        </template>
      </el-table-column>
      <el-table-column label="二级指标" width="180">
        <template slot-scope="scope">
          <span v-if="scope.row.wijPid !== null">{{scope.row.wijKeyName}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="wijPercentage" label="占比">
        <template slot-scope="scope">
          <span>{{scope.row.wijPercentage}}</span>
          <span>%</span>
        </template>
      </el-table-column>
      <el-table-column prop="wijRangeStart,wijRangeEnd" label="取值范围">
        <template slot-scope="scope">
          <div
            v-if="scope.row.wijRangeStart && scope.row.wijRangeEnd"
          >{{scope.row.wijRangeStart}}~{{scope.row.wijRangeEnd}}</div>
        </template>
      </el-table-column>
    </el-table>
    </div>

    <!-- 列表二 -->
    <el-table
      :data="tableList"
      class="listTowline"
      highlight-current-row
      v-loading="listLoading"
      style="width: 100%;"
      v-show="tableShowTwo"
    >
      <el-table-column label="一级指标" width="180">
        <template slot-scope="scope">
          <span v-if="scope.row.mrdPid == null">{{scope.row.mrdKeyName}}</span>
        </template>
      </el-table-column>
      <el-table-column label="二级指标" width="180">
        <template slot-scope="scope">
          <span v-if="scope.row.mrdPid !== null">{{scope.row.mrdKeyName}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="mrdPercentage" label="占比" width="180">
        <template slot-scope="scope">
          <span>{{scope.row.mrdPercentage}}</span>
          <span>%</span>
        </template>
      </el-table-column>
      <el-table-column prop="mrdRangeStart,mrdRangeEnd" label="取值范围">
        <template slot-scope="scope">
          <!-- <div v-if="scope.row.iwfRangeStart && scope.row.iwfRangeEnd"> -->
          {{scope.row.mrdRangeStart}}~{{scope.row.mrdRangeEnd}}
          <!-- </div> -->
        </template>
      </el-table-column>
    </el-table>
      <div slot="footer" class="dalog-footer">
        <el-button @click.native="handleClose()">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>


export default{
 props: {
    visible: {
      type: Boolean,
      default: false
    },
    viewFormDetail: {
      type: Object,
      default() {
          return {}
      }
    },
    pogList: {
      type: Array,
      default(){
        return []
      }
    },
  },
  data() {
    return {
      filters: {
        dept: "",
        spaceclassNew: "",
        sipMode: "",
        ssubclass: "",
        sipIndication: ""
      },
      planLists: [],
      listLoading: false,
      pageSize: 1, //页码
      pageRows: 20, //每页的条数
      totalNum: 0,
      goodsList: [],
      mrId: "",
      List: [],
      ssubList: [],
      tableShowOne: true,
      tableShowTwo: false,
      tableList: [],
      wijIwfversion: '',  //查看选品规则里查看权重展示版本
      pgtDisable: false,
    };
  },
  created() {
    this.filters.dept = this.viewFormDetail.dept;
    this.List = this.pogList;
    this.filters.spaceclassNew = this.viewFormDetail.spaceclassNew;
    this.filters.mrId = this.viewFormDetail.mrId;
    this.filters.sipMode = this.viewFormDetail.sipMode;
    this.filters.sipIndication = this.viewFormDetail.sipIndication;
    this.filters.sipId = this.viewFormDetail.sipId;
    this.filters.wijVersion = this.viewFormDetail.wijVersion;
    if(this.filters.mrId){
      this.tableShowTwo = true;
      this.tableShowOne = false;
      this.pgtDisable = true;
      this.filters.spaceclassNew = this.List.toString();
    }
    
  },
  methods: {
    handleClose(){
      this.$emit('update:visible', false);
      this.$refs["filters"].resetFields();
    },
    showListByWijVersion(ssub) {
      var _this = this;
      let para = {};
      if (!(ssub == null || ssub == undefined || ssub == "")) {
        para = { 
          wijPogcode: ssub,
          sipId: _this.filters.sipId,
          wijVersion: _this.filters.wijVersion
        };
      }
      this.listLoading = true;
      this.$api.selectgoods.showListByWijVersion(para).then(res => {
        this.totalNum = res.data.total;
        this.planLists = res.data.result;
        this.wijIwfversion = res.data.result[0].wijIwfversion;
        this.listLoading = false;
      });
    },
    getRowsCheck() {
      var _this = this;
      let para = {};
      let hasmrId = !(
        this.filters.mrId == null ||
        this.filters.mrId == undefined ||
        this.filters.mrId == ""
      );
      if (hasmrId) {
        
        if(this.filters.spaceclassNew.indexOf(",") > -1){
          para.mrId = this.filters.mrId;
        }else{
          para.mrId = this.filters.mrId;
          para.mrdPogcode = this.filters.spaceclassNew;
        }
        this.listLoading = true;
        this.$api.selectgoods.getShowAppdetailList(para).then(res => {
          this.totalNum = res.data.total;
          this.tableShowTwo = true;
          this.tableShowOne = false;
          this.tableList = res.data.result;
          this.listLoading = false;
        });
      }
    },
    getGoodsCategories() {
      var _this = this;
      let para = {};
      this.$api.selectgoods.getGoodsCategories(para).then(res => {
        this.goodsList = res.data.result;
      });
    },
    search() {
      this.pageSize = 1;
      if (this.filters.mrId) {
        this.getRowsCheck();
      } else {
        this.showListByWijVersion(this.filters.spaceclassNew); 
      }
    }
  },
  mounted() {
    this.getGoodsCategories();
    this.search();

  }
}
</script>


// WEBPACK FOOTER //
// src/views/selectgoods/selectionmanagement/listquery/look/weightSetCheckDetail.vue